import React from 'react';
import propTypes from 'prop-types';

const style = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    inset: 0,
};

function FullScreenContainer({ children }) {
    return (
        <div style={style}>
            <div className="relative flex flex-col justify-center min-h-screen overflow-hidden">
                {children}
            </div>
        </div>
    );
}

FullScreenContainer.propTypes = {
    children: propTypes.node,
};

export default FullScreenContainer;
